import * as React from 'react'

const ChevronDown = ({className, style}) => {
    return (<svg width="16" height="16" viewBox="0 0 16 16" fill="none" className={`${className} docsIcon`} style={style} xmlns="http://www.w3.org/2000/svg">
        <path d="M13 6L8 11L3 6" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>)
}

export default ChevronDown;